export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    handle: "@sarahm_work",
    avatarColor: "bg-[#E3F2FD]",
    text: "ScanDoc has completely replaced my office scanner. The auto-crop and perspective correction are incredibly accurate. I scan contracts daily and the quality is always perfect.",
    rating: 5,
  },
  {
    id: 2,
    name: "James Okafor",
    handle: "@jamesokafor_dev",
    avatarColor: "bg-[#E8F5E9]",
    text: "The OCR feature is outstanding — I extract text from printed documents and convert them to editable notes in seconds. A game changer for my workflow.",
    rating: 5,
  },
  {
    id: 3,
    name: "Marie Dubois",
    handle: "@marie.dubois",
    avatarColor: "bg-[#F3E5F5]",
    text: "I manage hundreds of invoices for my small business. The folder organization, merge PDF, and watermark features save me hours every week.",
    rating: 5,
  },
  {
    id: 4,
    name: "Raj Patel",
    handle: "@rajpatel_docs",
    avatarColor: "bg-[#FFF3E0]",
    text: "The signature tool makes remote contract signing so easy. I also love the compression feature — sharing large PDFs via email is no longer a problem.",
    rating: 5,
  },
  {
    id: 5,
    name: "Emily Zhang",
    handle: "@emilyz_study",
    avatarColor: "bg-[#E0F2F1]",
    text: "As a student, ScanDoc is essential. I scan lecture notes, apply AI Color filter to make them readable, and organize everything by subject. Love the dark mode too!",
    rating: 5,
  },
  {
    id: 6,
    name: "David Kim",
    handle: "@davidkim_legal",
    avatarColor: "bg-[#EDE7F6]",
    text: "The QR code generation and watermark tools are exactly what I needed for my legal practice. Professional output every time. Highly recommended.",
    rating: 5,
  },
];